import React, { useState, useEffect,useCallback } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { confirmAlert } from 'react-confirm-alert'; // Import
import DataGrid,{ Column }  from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-community/base.css';
import '@inovua/reactdatagrid-community/theme/amber-dark.css';
import "react-datepicker/dist/react-datepicker.css";
import '@szhsin/react-menu/dist/index.css';
import {
    Menu,
    MenuItem,
    MenuButton,
    SubMenu
} from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import {getEventoAyuda,deleteEventoAyuda,setStatusByKey} from "../../actions/evento";
import EditarGestionEventoAyuda from "./EditarGestionEventoAyuda";
import "../../config";

const GestionEventoAyuda = (props) => {
    let [editGestionEventoAyudaOpen, setEditGestionEventoAyudaOpen] = useState("")
    const {listaEventoAyuda,ayudaEventoLoading} = useSelector((state) => state.evento)
    let [ayudaPorEventoSeleccionado, setAyudaPorEventoSeleccionado] = useState("null")    
    let [loadEventoAyuda, setLoadEventoAyuda] = useState(false)
    let eventoIdSeleccionado = props.eventoSeleccionadoId;    
    const dispatch = useDispatch();
    function closeGestionAyudaClick(){
        dispatch(setStatusByKey("listaEventoAyuda",null))
        props.closeGestionAyuda();
    }    
    if(listaEventoAyuda===null && loadEventoAyuda ===false){
        setLoadEventoAyuda(true)
        dispatch(getEventoAyuda(eventoIdSeleccionado,"0","","","ASC",""))
        .then(() => {
        })
        .catch(() => {
        });
        
    }

    const gridStyle = { minHeight: '300px',height:'100%', margin: 20 }
    const renderRowContextMenu = useCallback((menuProps, { rowProps } ) => {
        menuProps.autoDismiss = true
        menuProps.items = [
        {
            label: 'Editar',
            onClick:()=>{   
                setAyudaPorEventoSeleccionado(rowProps.data)
                dispatch(getEventoAyuda(rowProps.data["EventoAyudaId"],"0","","","ASC",""))
                .then(() => {
                })
                .catch(() => {
                });
                setEditGestionEventoAyudaOpen("EDIT")        
            }
        },          
        {
        label: 'Eliminar',
            onClick:()=>{
                confirmAlert({
                    title: 'Eliminar ayuda',
                    message: '¿Seguro desea eliminar?.',
                    buttons: [
                      {
                        label: 'Si',
                        onClick: () =>{
                            dispatch(deleteEventoAyuda(rowProps.data["EventoAyudaId"],rowProps.data["EventoId"],"0","","","ASC",""))
                            .then(() => {     
                        
                            })
                            .catch(() => {});
                        }
                      },
                      {
                        label: 'No',
                        onClick: () => {}
                      }
                    ]
                  });
               
            }
        }
        ]
    }, [])  
    let columns= [
        /*{ name: 'EventoId', type: 'number', defaultWidth: 80 },*/
        { name: 'Jugada',header: 'Jugada', defaultFlex: 1, xdefaultLocked: 'end' },        
        { name: 'Estado',header: 'Estado', defaultFlex: 1, xdefaultLocked: 'end',render: ({ data }) => formatEstado(data["Estado"]) },          
       
    ]

    const closeEditGestionAyudaUsuario = ()=>{
        setEditGestionEventoAyudaOpen("")
    }
    const crearNuevo = ()=>{
        setAyudaPorEventoSeleccionado(null)
        setEditGestionEventoAyudaOpen("EDIT")
    }
	function formatEstado(estado){
		switch(estado){
			case "A":
				return "ACTIVO"
		}
		return "INACTIVO"
	}

return (
<div className="overlay3 fade-in"> 
    <div className={['loading_cont',ayudaEventoLoading!==true?"displaynone":""].join(' ')}><div className='single6'></div></div>
    {editGestionEventoAyudaOpen==="EDIT" ? <EditarGestionEventoAyuda closeEditGestionAyudaUsuario={closeEditGestionAyudaUsuario} ayudaPorEventoSeleccionado={ayudaPorEventoSeleccionado} eventoSeleccionadoId={eventoIdSeleccionado} />  :  
    <div className="borderContent ventanaGeneral">
        <div className="innerShadow-height-100">
            <h2>
            Ayuda por evento
            <div className="floatright">
                <Menu menuButton={<MenuButton><i className="fas fa-cog"></i></MenuButton>}>
                    <MenuItem onClick={crearNuevo}><i className="fas fa-sign-out-alt"></i>Nuevo</MenuItem> 
                </Menu>
            </div>
            </h2> 
            <DataGrid
                idProperty="EventoAyudaId"
                style={gridStyle}
                theme="default-light"                    
                columns={columns}
                enableSelection={true}
                selection={{ mode: 'single' }}                    
                dataSource={listaEventoAyuda!==null?listaEventoAyuda:[]}
                renderRowContextMenu={renderRowContextMenu}
                theme="amber-dark"
            />
             
            <div className="dividerLine"></div>
            <div className="textCenter">
                <div className="btnCancelar" onClick={closeGestionAyudaClick}>
                    SALIR
                </div>
            </div>      
        </div>       
    </div>
    }
</div>
);
}
const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, {})(GestionEventoAyuda);